module.exports = __webpack_public_path__ + "static/img/金税一言banner_pc.e83b988.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/金税一言banner_pc.png
// module id = Zcbt
// module chunks = 34